import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Handles the return from Emergent Google Auth.
 * URL fragment is expected to contain #session_id=<sid>.
 * Exchanges it with backend, which sets an httpOnly cookie.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Strip fragment from URL immediately
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        navigate("/admin/leads", { replace: true, state: { user: data } });
      } catch {
        navigate("/admin/login", { replace: true, state: { error: "Authentication failed. Please try again." } });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg text-white">
      <div className="text-center">
        <div className="mx-auto w-10 h-10 rounded-full border-2 border-indigo-400 border-t-transparent animate-spin" />
        <p className="mt-5 text-sm uppercase tracking-[0.25em] text-slate-400">
          Establishing secure session…
        </p>
      </div>
    </div>
  );
}
